export function IconSearchSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.667 11.6665L14.667 14.6665"
        stroke="#896145"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 7.33325C13.334 4.01954 10.6477 1.33325 7.33398 1.33325C4.02028 1.33325 1.33398 4.01954 1.33398 7.33325C1.33398 10.647 4.02028 13.3333 7.33398 13.3333C10.6477 13.3333 13.334 10.647 13.334 7.33325Z"
        stroke="#896145"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}
